const MAX_VAL = 99;
const withValueLimit = ({ value, floatValue }) => {
  // permitir borrar todo mientras se edita
  if (value === "" || value == null) return true;
  // restringir a [0, MAX_VAL]
  if (floatValue == null) return true;
  return floatValue >= 0 && floatValue <= MAX_VAL;
};

export const simulationParameters = [
	{
		name: "savingsToday", label: "Saved Amount",
		description: "Savings already accumulated for retirement", t: true, p: "$", tip: "Include money already set aside in retirement accounts, savings, or investments you plan to use for retirement."
	},
	{
		name: "saveYears", label: "Save Years",
		description: "Years you plan to keep saving before retirement", s: " years", rule: withValueLimit
	},
	{
		name: "pensionYears", label: "Pension Years",
		description: "Years you expect to live after retiring", s: " years", rule: withValueLimit
	},
	{
		name: "currentAnualIncome", label: "Current Annual Income",
		description: "Your current annual income", t: true, p: "$",
		tip: "Or if you are not working, what is your expected annual income once you start saving (in today's money)."
	},
	{
		name: "annualPension", label: "Desired Annual Pension",
		description: "Your initial annual income during retirement", t: true, p: "$", tip: "In today's money"
	},
	{
		name: "annualReturnRate", label: "Annual Return Rate",
		description: "Expected annual real return on retirement savings", s: "%", f: "2", tip: "4.00% Recommended, 3.00% if you are very conservative."
	},
	/*{
		name: "endingAnnualSalary", label: "Ending Annual Income",
		description: "Expected ending annual income just before retiring (in today's dollars)",
		t: true, p: "$", stage: "constantPercentage",
		tip: "What is being show is the result of your current annual income and your ending annual income just before retirement."
	},
	*/
	 {
		name: "incomeAnnualGrowthRate", label: "Income Annual Growth Rate",
		description: "Expected annual income growth rate",
		s: "%", f: "2", stage: "constantPercentage",
		tip: "Use 1% to 1.5% as a conservative estimate for real income growth.",
		fillColor: "#81ecec"
	},
	{
		name: "annualInflation", label: "Inflation",
		description: "Estimated annual inflation rate",
		s: "%", f: "2",
		tip: "Use 2%-3% for a conservative annual inflation rate. A máximum of 50% is allowed.", fillColor: "#f1c40f"
	},
	{
		name: "neededAmount", label: "Fund Size",
		description: "This is how much should you save in order to generate the desired pension. (In today's dollars)",
		rol: "output", t: true, p: "$",
		tip: "Total amount needed at the end of the savings period"
	},
	{
		name: "neededYearlySave", label: "Annual Savings",
		description: "Amount to be saved annually.", rol: "output", t: true, p: "$",
		tip: "Amount to be saved annually. Amount in dollars may change because of inflation or income growth. Amount in percentage will be preserved."
	},
	{
		name: "percetageYearlySave", label: "(%)",
		description: "This is the % of your income you need to save.", rol: "output", s: "%"
	},
	/*
	{
		name: "resultingAnnualGrowthRate", label: "Income Growth",
		description: "This is the resulting annual real growth rate of your income (it is usually between 3% and 4%)",
		s: "%", stage: "constantPercentage", rol: "output", f: "2",
		tip: `Income Growth. Represents how much your annual income increases every year. 
		This is the result of taking into account your current and expected annual income when you retire. If you want to assume income growth, use the advanced option 'Incorporate Income Growth' above.`,
		fillColor: "#81ecec"
	},
	*/
];

export const selectParameters = (params) =>{
	return  simulationParameters.filter(X=>params.includes(X.name));
}
